import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

class CameraEngineOrbital {
	// камера смотрит с большой высоты, можно свободно вращать мышью 
	
	camera: THREE.PerspectiveCamera;
	
	controls: OrbitControls;

	constructor(scene: THREE.Scene, canvas: any) {
		//
		console.log("CameraEngineOrbital.constructor, scene = " + scene);
		console.log("CameraEngineOrbital.constructor, canvas = " + canvas);

		this.camera = new THREE.PerspectiveCamera( 90, window.innerWidth / window.innerHeight, 0.01, 1500 );
		
//		this.camera.position.set(0, 500, 0);
		this.camera.position.set(0, 300, 0);
		this.camera.lookAt(0, 0, 0);
		
		scene.add(this.camera);
		
		
		this.controls = new OrbitControls(this.camera, canvas);
		this.controls.enableDamping = true;
		
		
	}
	/////////////////////////////////////////////////////////
	animate() {
		this.controls.update();
	}
	/////////////////////////////////////////////////////////
	getCamera() {
		return this.camera;
	}
	/////////////////////////////////////////////////////////
	
}
export default CameraEngineOrbital;